import React, {useEffect, useState} from "react";

function HelpSection(props){

    const menuStyleClosed = {
		display: "none"
    };
    const menuStyleOpen = {
		display: "block"
    };
	const [ menuStyle, setMenuStyle ] = useState(props.subMenuOpen?menuStyleOpen:menuStyleClosed);
	useEffect(() => {
		setMenuStyle(props.subMenuOpen?menuStyleOpen:menuStyleClosed)
	}, [props.subMenuOpen])
	function toggleShowItems() {
		if(menuStyle.display=='none')
			setMenuStyle(menuStyleOpen);
		else
			setMenuStyle(menuStyleClosed);
    }

    return (
		<a href="javascript:void(0)" className="helper__section__item" onClick={toggleShowItems}>
			<div className="helper__section__item__icon helper__section__item__icon--create"></div>
			<div className="helper__section__item__text">
				<div className="helper__section__item__text__title">{props.section.title}</div>
				<div className="helper__section__item__text__description">{props.section.description}
					<ul style={menuStyle}>
						{
							props.section.items.map((item) => {
								return (<li key={item.url}><a href={'/help-center/'+props.section.url+'/'+item.url}>{item.title}</a></li>)
							})
						}
					</ul>
				</div>
			</div>
		</a>
   );
}
export default HelpSection;